// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__195qw","content":"styles_content__1Yfto"};